import {
    CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO,
    LIBERAR_BLOQUEIO_POLTRONAS_TEMPORARIO
} from '../../actions/pedido/bloqueioPoltronasTemporarioActions';

const initialState = {
    bloqueios: [],
};

export default function reducerBloqueioPoltronasTemporario(state = initialState, action) {
    switch (action.type) {
        case CADASTRAR_BLOQUEIO_POLTRONAS_TEMPORARIO: {
            const bloqueios = [...state.bloqueios];
            bloqueios.push(action.payload.data);
            return {
                ...state,
                bloqueios: bloqueios
            };
        }

        case LIBERAR_BLOQUEIO_POLTRONAS_TEMPORARIO: {
            return {
                ...state,
                bloqueios: [...state.bloqueios].filter(it => !action.payload.includes(it.id))
            };
        }

        default: {
            return state
        }
    }
}
